import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  Model,
  QueryParams,
  PagedResponse,
  JSONPatchDocument,
  ValidatedResponse,
} from "@ofqual/portal-core/core/types";
import { PagedResponseTo } from "@ofqual/portal-core/core/utils/pagedResponseHelpers";
import { BusinessModel, fromApiModel } from "../domain/BusinessModel";
import { getValidationError } from "@ofqual/portal-core/core/utils/validationHelper";
const dummyApi: PagedResponse<Model> = {
  page: 0,
  pageSize: 25,
  count: 2,
  data: [
    {
      id: "1",
      title: "item 1",
      value: "1",
    },
    {
      id: "2",
      title: "item 2",
      value: "2",
    },
  ],
};
export class DummyService extends BaseRemoteService {
  public async get(id: string, opts: Opts): Promise<BusinessModel> {
    return fromApiModel(dummyApi.data.find((item) => item.id === id) || {});
  }
  public async search(
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<BusinessModel>> {
    return PagedResponseTo<BusinessModel>({ ...dummyApi }, fromApiModel);
  }
  public async update(
    id: string,
    patchDocument: JSONPatchDocument,
    opts: Opts
  ): Promise<ValidatedResponse<BusinessModel>> {
    await new Promise((resolve) => setTimeout(resolve, 500));
    window.alert(
      "Just a dummy service, would be sending the following to the api:" +
        JSON.stringify(patchDocument)
    );
    const item = fromApiModel(
      dummyApi.data.find((item) => item.id === id) || {}
    );
    return {
      isValid: true,
      data: fromApiModel(item),
    };
  }
  public async create(
    item: BusinessModel,
    opts: Opts
  ): Promise<ValidatedResponse<string>> {
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      window.alert(
        "Just a dummy service, would be sending the following to the api:" +
          JSON.stringify(item)
      );
      return {
        isValid: true,
        data: "foo",
      };
    } catch (err) {
      const validationError = getValidationError(err);
      if (validationError.isValidationError) {
        return { isValid: false, error: validationError.error };
      }
      throw err;
    }
  }
}
